var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { courseApiRequest } from "./client";
import {
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
var CourseElementType = /* @__PURE__ */ ((CourseElementType2) => {
  CourseElementType2["SPLIT"] = "CwSplit";
  CourseElementType2["UNIT"] = "CwUnit";
  CourseElementType2["LESSON"] = "CwLesson";
  CourseElementType2["ACTIVITY"] = "CwActivity";
  CourseElementType2["ASSESSMENT"] = "CwAssessment";
  CourseElementType2["TEST_CONTAINER"] = "CwTestContainer";
  CourseElementType2["EXAM_CONTAINER"] = "CwExamContainer";
  return CourseElementType2;
})(CourseElementType || {});
var AssessmentType = /* @__PURE__ */ ((AssessmentType2) => {
  AssessmentType2["QUIZ"] = "quiz";
  AssessmentType2["TEST"] = "test";
  AssessmentType2["EXAM"] = "exam";
  AssessmentType2["PRETEST"] = "lesson pretest";
  return AssessmentType2;
})(AssessmentType || {});
const _60_MINS = 1e3 * 60 * 60;
const sendReportIssueRequest = (data) => {
  return courseApiRequest({
    url: `/report-issue/zendesk`,
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    data
  }).catch((err) => {
    console.error("Error sending report issue.\n", err);
    return Promise.reject(
      new Error("Error sending report issue.", { cause: err })
    );
  });
};
const useReportIssueMutation = () => {
  return useMutation({
    mutationFn: (data) => sendReportIssueRequest(data)
  });
};
const fetchCourse = (courseId, {
  splitId,
  districtId,
  schoolId,
  sectionId,
  enrollmentId,
  customizationMode,
  customizationEdition
} = {}) => {
  return courseApiRequest({
    url: `/course/${courseId}`,
    method: "GET",
    headers: {
      "X-API-VERSION": "3"
    },
    params: {
      splitId,
      districtId,
      schoolId,
      sectionId,
      enrollmentId,
      customizationMode,
      customizationEdition
    }
  });
};
const fetchLessonStandards = (courseId, enrollmentId, districtId, schoolId, sectionId, lessonIdsToSearch) => {
  return courseApiRequest({
    url: `/course/${courseId}/alignmentStandards`,
    method: "GET",
    params: {
      enrollmentId,
      districtId,
      schoolId,
      sectionId,
      lessonIdsToSearch
    }
  });
};
function useCourseQuery(courseId, params = {}, options = {}) {
  const queryClient = useQueryClient();
  return useQuery(
    ["course", courseId, params],
    () => fetchCourse(courseId, params),
    __spreadProps(__spreadValues({}, options), {
      enabled: !!courseId,
      cacheTime: _60_MINS,
      staleTime: _60_MINS,
      onSuccess(course) {
        queryClient.setQueryData(["courseTitle"], course.title);
      }
    })
  );
}
function useLessonStandardsQuery(courseId, courseAlignmentsRequestParams, enabled) {
  return useQuery(
    [
      "course-alignments-response",
      courseAlignmentsRequestParams.lessonIdsToSearch
    ],
    () => fetchLessonStandards(
      courseId,
      courseAlignmentsRequestParams.enrollmentId,
      courseAlignmentsRequestParams.districtId,
      courseAlignmentsRequestParams.schoolId,
      courseAlignmentsRequestParams.sectionId,
      courseAlignmentsRequestParams.lessonIdsToSearch
    ),
    {
      enabled,
      onError: (error) => console.error(
        `Could not retrieve lesson alignments of course ${courseId}, lesson ${courseAlignmentsRequestParams.lessonIdsToSearch}.
`,
        error
      ),
      useErrorBoundary: false
    }
  );
}
const useCourseMutation = () => {
  return useMutation(
    ({ courseId, params }) => fetchCourse(courseId, params)
  );
};
function useCourseTitleQuery() {
  const queryClient = useQueryClient();
  return useQuery(
    ["courseTitle"],
    () => queryClient.getQueryData(["courseTitle"]),
    { staleTime: Infinity, cacheTime: Infinity }
  );
}
function useCourseElementQuery(courseId, courseElementId, params = {}, options = {}) {
  const queryClient = useQueryClient();
  return useQuery(
    ["course-element", courseId, courseElementId, params],
    () => __async(this, null, function* () {
      const course = queryClient.getQueryData(["course", courseId, params]) || (yield fetchCourse(courseId, params));
      if (course) {
        queryClient.setQueryData(["course", courseId], course);
        queryClient.setQueryData(["courseTitle"], course.title);
        return getCourseElement(course, (el) => el.id === courseElementId);
      }
      return void 0;
    }),
    __spreadProps(__spreadValues({}, options), { enabled: !!courseId && !!courseElementId })
  );
}
function getCourseElement(element, predicate) {
  var _a;
  if (predicate(element)) {
    return element;
  }
  for (let i = 0; i < ((_a = element.children) == null ? void 0 : _a.length); i++) {
    const currentChild = element.children[i];
    const result = getCourseElement(currentChild, predicate);
    if (result) {
      return result;
    }
  }
  return void 0;
}
function getCourseElements(element, predicate) {
  const results = [];
  if (!element) {
    return;
  }
  function collectCourseElements(_elements = []) {
    for (let child of _elements) {
      if (predicate(child)) {
        results.push(child);
      } else {
        collectCourseElements(child.children || []);
      }
    }
  }
  const children = Array.isArray(element) ? element : element.children;
  collectCourseElements(children || []);
  return results;
}
function getLessonParent(lessonId, root) {
  if (!root || !lessonId) {
    return [];
  }
  let lessonParent = [];
  for (const child of root.children) {
    if (child.type === "CwLesson" /* LESSON */ && child.id === lessonId) {
      lessonParent.push(root);
    }
    if (!lessonParent.length) {
      lessonParent = lessonParent.concat(getLessonParent(lessonId, child));
      if (lessonParent.length)
        break;
    }
  }
  return lessonParent;
}
function getCurrentElementAndParents(children, courseElementId) {
  if (!children || !courseElementId) {
    return [];
  }
  let currentElementAndParents = [];
  children.forEach((child) => {
    if (child.id === courseElementId) {
      currentElementAndParents.push(child);
    }
    if (!currentElementAndParents.length) {
      currentElementAndParents = currentElementAndParents.concat(
        getCurrentElementAndParents(child.children, courseElementId)
      );
      if (currentElementAndParents.length) {
        currentElementAndParents.unshift(child);
      }
    }
  });
  return currentElementAndParents;
}
export {
  AssessmentType,
  CourseElementType,
  fetchLessonStandards,
  getCourseElement,
  getCourseElements,
  getCurrentElementAndParents,
  getLessonParent,
  useCourseElementQuery,
  useCourseMutation,
  useCourseQuery,
  useCourseTitleQuery,
  useLessonStandardsQuery,
  useReportIssueMutation
};
